import React, { useState, useRef, useContext, useEffect } from "react";
import { Formik } from "formik";
import InputTxt from "../framework/InputTxt";
import Button from "../framework/Button";
import Ribbon from "../framework/Ribbon";
import CollapseBar from "../framework/CollapseBar";
import PhoneInput from "../framework/PhoneInput";
import DOBInput from "../framework/DOBInput";
import Dropdown from "../framework/DropdownObj";
import RadioButtons from "../framework/RadioButtonsObj";
import DateInput from "../framework/DateInput";
import { DATA_REQUEST_FORM_OBJECT } from '../components/DataRequestFormObject';
import { COUNTRIES_LIST } from "../components/Countries";
import webRootContext from "../components/webrootcontext/WebRootContext";


import { UserProfile } from "../components/UserProfileProvider";


function DataRequestForm() {
	
	const initialized = useRef(false);
	const [saveSuccess, setSaveSuccess] = useState();
	const [saveFailed, setSaveFailed] = useState();
	const [formikError, setFormikError] = useState();
	const [formSubmitted, setFormSubmitted] = useState();
	const [dataRequestFormObject, setDataRequestFormObject] = useState(DATA_REQUEST_FORM_OBJECT);
	const [isPreviousEmp, setIsPreviousEmp] = useState();
	const [isPreviousEmpObj, setIsPreviousEmpObj] = useState();
	const [applicantId, setApplicantId] = useState();
	const [dataRequestFormCompleted, setDataRequestFormCompleted] = useState(false);
	const [applicationAccepted, setApplicationAccepted] = useState();
	const [finalObj, setFinalObj] = useState();
	const [initInstitution, setInitInstitution] = useState("");
	const [applicationCompleted, setApplicationCompleted] = useState(false);
	const [citizenshipCountrySelect, setCitizenshipCountrySelect] = useState();
	const [citizenshipCountryOtherSelected, setCitizenshipCountryOtherSelected] = useState(false);
	const [citizenshipCountryOtherValue, setCitizenshipCountryOtherValue] = useState("");
	const [saving, setSaving] = useState(false);

	const getApplicantIdUrl = webRootContext + "/rest/dashboard/getApplicantId";
	const currentContext = useContext(UserProfile);
	const tempFN = currentContext.userProfile.firstName;
	const tempLN = currentContext.userProfile.lastName;
	const tempEmail = currentContext.userProfile.email;
	const tempCountry = currentContext.userProfile.country;
	const marginStyle = { marginBottom: "0 !important" };

	const getDashboardStatusUrl = webRootContext + "/rest/dashboard/getStatus";

	const checkKeyDown = (e) => {
		if (e.key === 'Enter') e.preventDefault();
	}

	const dobRef = useRef();


	const [errorMessageArray] = useState([
		"Date of birth is required",
		"Enter a month value between 1 and 12",
		"Enter a day value between 1 and ",
		"Enter a year value between 1900 and present",
		"Enter a date in the past."
	]);

	const linkStyle = {
		fontSize: "16px",
		color: "#007dba",
		textDecoration: "underline",
		textTransform: "none"
	};


	const mailToEmail = "mailto:" + tempEmail;

	let citizenshipDropDownList = [
		{ id: 0, value: "", label: "Select one", selected: true },
		{ id: 1, value: "US Citizen", label: "US Citizen", selected: false },
		{ id: 2, value: "B1 - Visitor - Business", label: "B1 - Visitor - Business", selected: false },
		{ id: 3, value: "B2 - Visitor - Tourist", label: "B2 - Visitor - Tourist", selected: false },
		{ id: 4, value: "ESTA", label: "ESTA", selected: false },
		{ id: 5, value: "F1 - Student", label: "F1 - Student", selected: false },
		{ id: 6, value: "F2 - Dependent of Student", label: "F2 - Dependent of Student", selected: false },
		{ id: 7, value: "H1 - Temp Visa - Dist Merit", label: "H1 - Temp Visa - Dist Merit", selected: false },
		{ id: 8, value: "H2 - Temp Visa - Other", label: "H2 - Temp Visa - Other", selected: false },
		{ id: 9, value: "J1 - Exchange Visa", label: "J1 - Exchange Visa", selected: false },
		{ id: 10, value: "J2 - Dependent of Exchange Visa", label: "J2 - Dependent of Exchange Visa", selected: false },
		{ id: 11, value: "O1 - Aliens of Extraordinary Ability", label: "O1 - Aliens of Extraordinary Ability", selected: false },
		{ id: 12, value: "P0 - Permanent Resident", label: "P0 - Permanent Resident", selected: false },
		{ id: 13, value: "TN - Canadian/Mexican Services", label: "TN - Canadian/Mexican Services", selected: false },
		{ id: 14, value: "OTHER", label: "OTHER", selected: false }
	];


	let yesno_radio_button_data = [
		{ id: 1, value: 1, label: "Yes", name: "Yes", selected: false },
		{ id: 2, value: 0, label: "No", name: "No", selected: false }
	];

	let yesNoUnknown_radio_button_data = [
		{ id: 1, value: 1, label: "Yes", name: "Yes", selected: false },
		{ id: 2, value: 0, label: "No", name: "No", selected: false },
		{ id: 3, value: 2, label: "Unknown", name: "Unknown", selected: false }
	];

	/*for radio buttons with static data,  we need to use useState to set the initial value, otherwise the radio button
  component  will not display correctly with selected option.*/
	const [yesno_radio_button] = useState(yesno_radio_button_data);
	const [yesNoUnknown_radio_button] = useState(yesNoUnknown_radio_button_data);

	//function to validate date entered is a past date 
	function isPastDate(dateToTest) {
		let dateInPast = false;
		let currentDay = new Date();
		let tempStartDate = new Date(dateToTest);

		if (tempStartDate < currentDay) {
			dateInPast = true;
		}

		return dateInPast;
	}

	function isDateBefore(startDate, endDate) {
		let startDateBefore = false;
		let tempStartDate = new Date(startDate);
		let tempEndDate = new Date(endDate);

		if (tempStartDate > tempEndDate) {
			startDateBefore = true;
		}

		return startDateBefore;
	}

	const saveSuccessContent =
		<div>
			<div className="padding-bottom-30">Thank you for submitting your data request form. We will contact you if additional information is required.</div>
			<div className="padding-bottom-30">Please add the Observership Program email address (observership.program@childrens.harvard.edu) to your "safe sender list" to make sure you receive program communications.</div>
			<div>Warm Regards,</div>
			<div className="padding-bottom-30">Boston Children’s Hospital, International Health Education</div>
			<div className="collapseBar_title">Observership Program</div>
			<div>International Health Education | Boston Children’s Hospital</div>
			<div className="padding-bottom-30"> <a href="mailto:observership.program@childrens.harvard.edu">observership.program@childrens.harvard.edu</a></div>
			<div><Button text={"RETURN TO DASHBOARD"} styleName={"button button--primary"} id={"returnForm"} onClick={(e) => { returnToDashboard(); }} /></div>
		</div>;

	const saveFailedContent =
		<div>
			<div className="padding-bottom-30">Sorry, an error has occured.</div>
			<div className="padding-bottom-30">Please review your form below. If your problems continue, please email the Observership Program at <a href="mailto:observership.program@childrens.harvard.edu">observership.program@childrens.harvard.edu</a>.</div>
		</div>;

	const alreadySubmittedContent =
		<div>
			<div className="padding-bottom-30">This task has already been submitted.</div>
			<Button
				text={"RETURN TO DASHBOARD"}
				styleName={"button button--primary"}
				id={"button_submit"}
				type="submit"
				onClick={(e) => { returnToDashboard(); }}
			/>
		</div>;

	const notApplicableContent =
		<div>
			<div className="padding-bottom-30">Please return to the dashboard to view the status of your application and how to proceed.</div>
			<Button
				text={"RETURN TO DASHBOARD"}
				styleName={"button button--primary"}
				id={"button_submit2"}
				type="submit"
				onClick={(e) => { returnToDashboard(); }}
			/>
		</div>;


	useEffect(() => {
		function getApplicantInfo() {
			fetch(getApplicantIdUrl, {
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				mode: "cors"
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {

					setApplicantId(data.applicantId);

					let country = COUNTRIES_LIST.find(e => e.value === data.citizenshipCountry);
					if (country === null || country === undefined || !country) {
						setCitizenshipCountryOtherSelected(true);
						setCitizenshipCountrySelect(COUNTRIES_LIST.find(e => e.value === "Other"));
						setCitizenshipCountryOtherValue(data.citizenshipCountry);
					}
					else {
						setCitizenshipCountrySelect(country);
					}
					setDataRequestFormObject({ ...dataRequestFormObject, citizenshipCountry : data.citizenshipCountry});

					setApplicationCompleted(data.isApplicationCompleted);
					if (data.currentInstitution !== "") {
						//setTimeout(() => {
						setInitInstitution(data.currentInstitution);
						//}, 100);
					}
					getDashboardStatusData(data.applicantId);



				}, (error) => {
					console.log("dashboard error: ", error);
				});
		}

		//Check to see if the user has already completed form 
		function getDashboardStatusData(applicantId) {
			const url = getDashboardStatusUrl + "?applicantId=" + applicantId;
			let formCompleted = false;

			fetch(url, {
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				mode: "cors"
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					setApplicationAccepted(data.applicantId > 0 && data.isAccepted);

					for (const item in data.requirementList) {
						if (data.requirementList[item].label === "Data Request Form" && data.requirementList[item].status === "completed") {
							formCompleted = true;
							break;
						}
					}

					setDataRequestFormCompleted(formCompleted);
				}, (error) => {
					console.log("dashboard error: ", error);
				});
		};
		if(!initialized.current){
			getApplicantInfo();
			initialized.current = true;
		}
		

	}, [getApplicantIdUrl, 
		applicantId, getDashboardStatusUrl, initInstitution, setDataRequestFormObject, 
		dataRequestFormObject, setCitizenshipCountryOtherSelected, setCitizenshipCountrySelect
	]);


	function populateNameEmail(values) {
		let tmpDates = "N/A";
		let tmpEmployeeId = "";
		if (values.previousBCHEmployee === 1) {
			tmpDates = values.previousEmploymentDate_start + ' to ' + values.previousEmploymentDate_end;
			tmpEmployeeId = dataRequestFormObject.previousEmployeeId;
		}

		let citizenCountryVal = "";
		if(citizenshipCountryOtherSelected){
			citizenCountryVal = citizenshipCountryOtherValue;
		}
		else{
			citizenCountryVal = dataRequestFormObject.citizenshipCountry;
		}

		setFinalObj({ ...dataRequestFormObject, 
			firstName: tempFN, 
			lastName: tempLN, 
			userEmail: tempEmail, 
			applicantId: applicantId, 
			homeInstitution: values.homeInstitution, 
			livedInUSA: values.livedInUSA, 
			previousBCHEmployee: values.previousBCHEmployee, 
			previousEmployeeId: tmpEmployeeId, 
			previousEmploymentDate: tmpDates,
			citizenshipCountry : citizenCountryVal
		});
	};


	function returnToDashboard() {
		window.location.href = webRootContext + "/ApplicantDashboard";
	}

	function SubmitForm() {

		let url = webRootContext + "/rest/adrForm/saveAdrForm";
		fetch(url, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(finalObj),
			mode: "cors"
		})
			.then((response) => {

				setSaving(false);
				if (response.ok) {

					// Clear the form and display the success message.
					setDataRequestFormObject(DATA_REQUEST_FORM_OBJECT);
					setSaveSuccess(true);
					setSaveFailed(false);

				} else {

					setSaveSuccess(false);
					setSaveFailed(true);
					//return null
				}
				return response.json();
			})
			.catch((err) => {
				//setSaveSuccess(false);
				//setSaveFailed(true);  
				console.log("error", err);
			});
	}

	if (saving) return (<div className="div_1_col padding-top-30 normal_txt">Saving Data Request Form</div>)



	//if(!isLoading){
	return (
		<div>
			<div id="completed" className={!applicationCompleted && dataRequestFormCompleted ? 'show_div' : 'hide_div'}>
				<div id="alreadySubmittedDiv" className="div_1_col">
					<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={alreadySubmittedContent} />
				</div>
			</div>


			<div id="noAcceptedApplication" className={!applicationCompleted && (applicationAccepted || applicationAccepted === undefined) ? 'hide_div' : 'show_div'}>
				<div id="notApplicableDiv" className="div_1_col">
					<Ribbon label="RETURN TO DASHBOARD" status={"error"} subheader={""} content={notApplicableContent} />
				</div>
			</div>


			<div id="formikForm" className={applicationCompleted || dataRequestFormCompleted || !applicationAccepted ? 'hide_div' : 'show_div'}>
				<Formik
					initialValues={{
						firstName: tempFN,
						lastName: tempLN,
						userEmail: tempEmail,
						phoneNumber: "",
						dob: "",
						emergencyContactName: "",
						emergencyPhoneNumber: "",
						birthCountry: tempCountry,
						citizenshipCountry: dataRequestFormObject.citizenshipCountry,
						otherCitizenshipCountry: citizenshipCountryOtherValue,
						citizenship: "",
						homeInstitution: null,
						livedInUSA: "",
						previousBCHEmployee: "",
						ssnLastFourDigits: "",
						previousEmploymentDate_start: "",
						previousEmploymentDate_end: ""
					}}


					validate={values => {
						const errors = {};

						if (!values.citizenship || values.citizenship === null || values.citizenship === "") {
							errors.citizenship = 'Citizenship/Visa type is required';
						}


						if (!values.firstName) {
							errors.firstName = 'First name is required';
						}
						if (values.firstName.length >= 50) {
							errors.firstName = 'First name must be less than 50 characters';
						}


						if (!values.lastName) {
							errors.lastName = 'Last name is required';
						}
						if (values.lastName.length >= 50) {
							errors.lastName = 'Last name must be less than 50 characters';
						}

						if (!values.emergencyPhoneNumber) {
							errors.emergencyPhoneNumber = 'Emergency phone number is required';
						}
						else if (!values.isValidEmergencyPhoneNumber) {
							errors.emergencyPhoneNumber = 'Enter a valid emergency phone number';
						}

						if (!values.phoneNumber) {
							errors.phoneNumber = 'Phone number is required';
						}
						else if (!values.isValidPhoneNumber) {
							errors.phoneNumber = 'Enter a valid phone number';
						}

						if (!values.dob) {
							errors.dob = 'Date of birth is required';
						}

						if (!values.emergencyContactName || values.emergencyContactName.trim() === "") {
							errors.emergencyContactName = 'Emergency contact name is required';
						}
						if (values.emergencyContactName.length >= 100) {
							errors.emergencyContactName = 'Emergency contact name must be less than 100 characters';
						}
						
						if(!values.citizenshipCountry && dataRequestFormObject.citizenshipCountry)
						{
							values.citizenshipCountry = dataRequestFormObject.citizenshipCountry;		
						}

						//added for JWM-4319 - values wasn't getting the initial value from the object
						//need to manually set it so form validation didn't throw an error for a prefilled value
						//if component has not been touched
						if(citizenshipCountryOtherSelected){
							if(!values.otherCitizenshipCountry || values.otherCitizenshipCountry.trim() === ""){
								errors.otherCitizenshipCountry = "Other country/region is required.";
							}
						}
						else if(!values.citizenshipCountry || values.citizenshipCountry.trim() === ""){
							errors.citizenshipCountry = "Country of citizenship is required.";
						}

						setDataRequestFormObject({ ...dataRequestFormObject, birthCountry: tempCountry });

						if (initInstitution !== "" && values.homeInstitution == null) {
							values.homeInstitution = initInstitution;
						}

						if (!values.homeInstitution || values.homeInstitution.trim() === "") {
							errors.homeInstitution = 'Home institution is required';
						}

						if (values.homeInstitution.length >= 100) {
							errors.homeInstitution = 'Home institution must be less than 100 characters';
						}

						if (values.livedInUSA === '') {
							errors.livedInUSA = 'Have you ever lived in the USA for a period of 6 months or more is required';
						}

						if (values.previousBCHEmployee === '') {
							errors.previousBCHEmployee = 'Previous BCH employee or associated personnel is required';
						}



						if (values.previousBCHEmployee === 1 && (!values.previousEmploymentDate_start || values.previousEmploymentDate_start === "")) {
							errors.previousEmploymentDate_start = "Previous BCH start date is required";
						}

						else if (values.previousBCHEmployee === 1 && !isPastDate(values.previousEmploymentDate_start)) {
							errors.previousEmploymentDate_start = "Enter a date in the past";
						}

						if (values.previousBCHEmployee === 1 && (!values.previousEmploymentDate_end || values.previousEmploymentDate_end === "")) {
							errors.previousEmploymentDate_end = "Previous BCH end date is required";
						}

						else if (values.previousBCHEmployee === 1 && !isPastDate(values.previousEmploymentDate_end)) {
							errors.previousEmploymentDate_end = "Enter a date in the past";
						}

						else if (values.previousBCHEmployee === 1 && isDateBefore(values.previousEmploymentDate_start, values.previousEmploymentDate_end)) {
							errors.previousEmploymentDate_end = "Enter a date after start date";
						}


						let reg1 = /^\d+$/;
						if (!values.ssnLastFourDigits || values.ssnLastFourDigits.trim() === "") {
							errors.ssnLastFourDigits = 'Last four digits of National ID/Social security number is required';
						} else if (!reg1.test(values.ssnLastFourDigits) || values.ssnLastFourDigits.trim().length < 4) {
							errors.ssnLastFourDigits = 'Enter a 4-character value containing numbers only';
						}


						if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.userEmail)) {
							errors.userEmail = 'Enter a valid email address using this format: example@mail.com';
						}

						if (!values.userEmail || values.userEmail.trim().length === 0) {
							errors.userEmail = 'Email address is required';
						}


						if (Object.keys(errors).length > 0) {
							setFormikError(true);
						}

						else {
							setFormikError(false);
						}

						return errors;
					}}
					validateOnBlur={true}

					onSubmit={(values, { setSubmitting }) => {

						setTimeout(() => {
							SubmitForm(values);
							setSubmitting(false);
							//hide form once it's submitted  
							setSaving(true);
						}, 100);
					}}
				>

					{({
						values,
						errors,
						touched,
						handleChange,
						handleBlur,
						handleSubmit,
						isSubmitting,
						isValid,
						dirty,
						validateForm,
						setFieldValue
					}) => (

						<form onSubmit={handleSubmit} onKeyDown={(e) => checkKeyDown(e)} noValidate>

							<div id="formikErrors" className={(formikError && formSubmitted ? 'show_div' : 'hide_div')}>
								<div id="formikFailDiv" className="div_1_col">
									<Ribbon label="REVIEW ISSUES BELOW" status={"error"} subheader={""} content={""} />
								</div>
							</div>

							<div id="saveSuccess" className={(saveSuccess ? 'show_div' : 'hide_div')}>
								<div id="saveSuccessDiv" className="div_1_col">
									<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={saveSuccessContent} />
								</div>
							</div>

							<div id="saveFailed" className={(saveFailed === 'true' ? 'show_div' : 'hide_div')}>
								<div id="saveFailedDiv" className="div_1_col">
									<Ribbon label="ERROR" status={"error"} subheader={""} content={saveFailedContent} />
								</div>
							</div>

							<div id="headerDiv" className={saveSuccess ? 'hide_div' : 'show_div div_1_col padding-bottom-20'}>
								<div className="breadcrumbLink"><a href="##" onClick={(e) => { returnToDashboard(); }}>Dashboard</a></div>
								<div className="page_title">Data Request Form</div>
							</div>

							<div id="formInputs" className={(saveSuccess ? 'hide_div' : 'show_div')} >

								<div id="divPageInfo" className="div_1_col normal_txt padding-bottom-30">All incoming observers must provide the following information to initiate the Human Resources clearance process required to visit.</div>

								<CollapseBar id={"cb1"} title={"Contact Information"} showNewLink={false} showMoveTop={false} showCollapseBT={false} initStateExpand={true} />


								<div id="div1" className="div_3_col">
									<h3 style={marginStyle}>{tempFN} {tempLN}</h3>
									<div className="padding-bottom-30"><a style={linkStyle} href={mailToEmail}>{tempEmail}</a></div>

									<Dropdown
										id="citizenshipCountry"
										name="citizenshipCountry"
										label="Country of citizenship"
										isRequired={true}
										isDisabled={false}
										helpMessage=""
										data={COUNTRIES_LIST}
										selectedItem={citizenshipCountrySelect}
										disableDefault={false}
										getSelectedValue={(citizenshipCountrySel) => {
											if(citizenshipCountrySel.value !== "Other"){
												setDataRequestFormObject({ ...dataRequestFormObject, citizenshipCountry : citizenshipCountrySel.value});
											}
											else{
												setDataRequestFormObject({ ...dataRequestFormObject, citizenshipCountry : citizenshipCountryOtherValue});
											}
										}}
										errorMessage={errors.citizenshipCountry}
										hasError={touched.citizenshipCountry && errors.citizenshipCountry}
										onChange={(citizenshipCountrySel) => {
											if(citizenshipCountrySel){
												if(citizenshipCountrySel.value === "Other"){
													setCitizenshipCountryOtherSelected(true);
												}
												else{
													values.citizenshipCountry = citizenshipCountrySel.value;
													setDataRequestFormObject({ ...dataRequestFormObject, citizenshipCountry : citizenshipCountrySel.value});
													setCitizenshipCountryOtherSelected(false);
												}
											}
											else{
												values.citizenshipCountry = "";
												setDataRequestFormObject({ ...dataRequestFormObject, citizenshipCountry : ""});
												setCitizenshipCountryOtherSelected(false);
											}
										}}
										onFocus={(e) => {
											touched.citizenshipCountry = e;
										}}
										onBlur={(e) => handleBlur(e)}

									/>
									<div className={(citizenshipCountryOtherSelected ? 'show_div' : 'hide_div')}>

										<InputTxt
											id="otherCitizenshipCountry"
											name="otherCitizenshipCountry"
											labelText="Other country/region"
											helpMessage=""
											isRequired={citizenshipCountryOtherSelected ? true : false}
											maxLength={150}
											errorMessage={errors.otherCitizenshipCountry}
											hasError={touched.otherCitizenshipCountry && errors.otherCitizenshipCountry}
											onChange={handleChange}
											onBlur={handleBlur}
											value={()=>{
												values.otherCitizenshipCountry = citizenshipCountryOtherValue;
												return citizenshipCountryOtherValue;
											}}
											getTextString={(otherCitizenshipCountrytxt) => {
												setCitizenshipCountryOtherValue(otherCitizenshipCountrytxt);
												values.otherCitizenshipCountry = otherCitizenshipCountrytxt;
											}}
										/>
									</div>

									<PhoneInput
										id="phoneNumber"
										name="phoneNumber"
										labelText={"Phone number"}
										isRequired={true} // add requird star
										isDisabled={false} // disable the inputbox
										showFlag={true} // without flag, US number only
										errorMessage={errors.phoneNumber}
										helpMessage={"Select the flag icon to choose your country, then enter your phone number"}
										hasError={touched.phoneNumber && errors.phoneNumber}
										// onchange and onblur is return event, handle by formik
										onChange={(e) => {
											setDataRequestFormObject({ ...dataRequestFormObject, phoneNumber: e });
											values.phoneNumber = e;
										}}
										onBlur={(e) => {
											touched.phoneNumber = true;
											//the e.phoneNumberHasError is mis-named, it is true if the number is correct 
											values.isValidPhoneNumber = e.phoneNumberHasError;
											validateForm();
										}}
										value={dataRequestFormObject.phoneNumber}
									/>



									<DOBInput
										ref={dobRef}
										id={"dob"}
										labelText={"Date of birth (MM DD YYYY)"}
										isRequired={true} // add requird star
										isDisabled={false} // disable the inputbox
										errorMessageArray={errorMessageArray}
										value={values.dob} // formik initial Values
										hasError={touched.dob && errors.dob}
										errorMessage={errors.dob}
										allowFutureDate={false}
										onFocus={(e) => {
										}}

										onChange={(e) => {
											values.dob = e;
											touched.dob = true;
										}}

										onBlur={(e) => {
											values.dob = e; // return value error or date string
											touched.dob = true;
											setDataRequestFormObject({ ...dataRequestFormObject, dob: e });

										}}
									/>

									<div className="horizontal_div">
										<InputTxt
											id="emergencyContactName"
											name="emergencyContactName"
											labelText="Emergency contact name"
											isRequired={true}
											errorMessage={errors.emergencyContactName}
											hasError={touched.emergencyContactName && errors.emergencyContactName}
											onChange={handleChange}
											onBlur={handleBlur}
											maxLength={"100"}
											value={values.emergencyContactName}
											getTextString={(e) => setDataRequestFormObject({ ...dataRequestFormObject, emergencyContactName: e })}
										/>

										<PhoneInput
											id="emergencyPhoneNumber"
											name="emergencyPhoneNumber"
											labelText={"Emergency phone number"}
											isRequired={true} // add requird star
											isDisabled={false} // disable the inputbox
											showFlag={true} // without flag, US number only
											errorMessage={errors.emergencyPhoneNumber}
											helpMessage={"Select the flag icon to choose your country, then enter your phone number"}
											hasError={touched.emergencyPhoneNumber && errors.emergencyPhoneNumber}
											// onchange and onblur is return event, handle by formik
											onChange={(e) => {
												setDataRequestFormObject({ ...dataRequestFormObject, emergencyPhoneNumber: e });
												values.emergencyPhoneNumber = e;
											}}
											onBlur={(e) => {
												touched.emergencyPhoneNumber = true;
												//the e.phoneNumberHasError is mis-named, it is true if the number is correct 
												values.isValidEmergencyPhoneNumber = e.phoneNumberHasError;
												validateForm();
											}}
											value={dataRequestFormObject.emergencyPhoneNumber}
										/>
									</div>
								</div>

								<CollapseBar id={"cb2"} title={"Background Information"} showNewLink={false} showMoveTop={false} showCollapseBT={false} initStateExpand={true} />

								<div id="div2" className="div_3_col">


									<Dropdown
										data={citizenshipDropDownList}
										label="Citizenship/Visa type"
										isRequired={true}
										helpMessage=""
										isDisabled={false}
										name="citizenship"
										id="citizenship"
										selectedItem={values.citizenship}
										disableDefault={true}
										getSelectedValue={(e) => { setDataRequestFormObject({ ...dataRequestFormObject, citizenship: e.value }); }}
										// show error and error message is control by formik
										errorMessage={errors.citizenship}
										hasError={touched.citizenship && errors.citizenship}
										// return event to formik
										onChange={(e) => {
											errors.citizenship = "";
											if (e) {
												values.citizenship = e.value;
												setDataRequestFormObject({ ...dataRequestFormObject, citizenship: e.value });

											}
										}}
										onFocus={(e) => {
											touched.citizenship = e;
										}}
										onBlur={(e) => handleBlur(e)}
										// update formik value
										value={(e) => {
											values.citizenship = e.value;
										}}
									/>

									<InputTxt
										id="homeInstitution"
										name="homeInstitution"
										labelText="Home institution"
										isRequired={true}
										errorMessage={errors.homeInstitution}
										hasError={touched.homeInstitution && errors.homeInstitution}
										onChange={(e) => {
											setDataRequestFormObject({ ...dataRequestFormObject, homeInstitution: e.target.value });
											values.homeInstitution = e.target.value;
											touched.homeInstitution = e;
										}}
										onBlur={(e) => {
											setDataRequestFormObject({ ...dataRequestFormObject, homeInstitution: e.target.value });
											values.homeInstitution = e.target.value;
											touched.homeInstitution = e;
											validateForm();
										}}
										helpMessage="Name of your institution, university, or organization"
										maxLength={"100"}
										//value={values.homeInstitution}
										value={initInstitution}
										getTextString={(e) => {
											setDataRequestFormObject({ ...dataRequestFormObject, homeInstitution: e });
											values.homeInstitution = e;
										}
										}
									/>






									<RadioButtons
										id={"livedInUSA"}
										label={"Have you ever lived in the USA for a period of 6 months or more?"}
										name="livedInUSA"
										// init data array setup radio buttons
										data={yesno_radio_button}
										isRequired={true}
										layoutVertical={false}
										selectedItem={values.livedInUSA}
										value={(e) => {
										}}
										onChange={(e) => {
											errors.livedInUSA = "";
											values.livedInUSA = e.value;
											if (e) {
												setDataRequestFormObject({ ...dataRequestFormObject, livedInUSA: e.value });
											}

										}}

										// if touched and has error
										hasError={touched.livedInUSA && errors.livedInUSA}
										// get error message from errors
										errorMessage={errors.livedInUSA}
										// on forcus, change touched to true
										onFocus={(e) => {
											touched.livedInUSA = e;
										}}
										onBlur={(e) => {
											validateForm();
										}}
									/>



									<RadioButtons
										id={"previousBCHEmployee"}
										label={"Previous BCH employee or associated personnel"}
										name="previousBCHEmployee"
										// init data array setup radio buttons
										data={yesNoUnknown_radio_button}
										isRequired={true}
										layoutVertical={false}
										selectedItem={isPreviousEmpObj}
										value={(e) => {
										}}
										onChange={(e) => {
											errors.previousBCHEmployee = "";
											values.previousBCHEmployee = e.value;
											if (e) {
												setIsPreviousEmp(e.value);
												setIsPreviousEmpObj(e);
												setDataRequestFormObject({ ...dataRequestFormObject, previousBCHEmployee: e.value, previousEmployeeId: "" });

												values.previousEmployeeId = "";


											}
										}}

										// if touched and has error
										hasError={touched.previousBCHEmployee && errors.previousBCHEmployee}
										// get error message from errors
										errorMessage={errors.previousBCHEmployee}
										// on forcus, change touched to true
										onFocus={(e) => {
											touched.previousBCHEmployee = e;
										}}
										onBlur={(e) => {

											validateForm();
										}}
									/>

									<div id="subDiv" style={{ "paddingLeft": "0" }} className={(isPreviousEmp === 1 ? 'show_div div_3_col' : 'hide_div')}>
										<div className="normal_txt">Dates of previous engagement</div>
										<div className="horizontal_div">
											<DateInput
												ref={dobRef}
												id={"previousEmploymentDate_start"}
												name={"previousEmploymentDate_start"}
												value={dataRequestFormObject.previousEmploymentDate_start}
												label={"Start Date"}
												isRequired={isPreviousEmp === 1 ? true : false}
												disableFuture={true}
												onChange={(date) => {
													if (date) {
														let tempStartDate = date.toLocaleDateString('en-US', { year: "numeric", month: "2-digit", day: "2-digit", });
														setDataRequestFormObject({ ...dataRequestFormObject, previousEmploymentDate_start: tempStartDate });
														values.previousEmploymentDate_start = tempStartDate;
													} else {
														setDataRequestFormObject({ ...dataRequestFormObject, previousEmploymentDate_start: "" });
														values.previousEmploymentDate_start = null;
													}
													validateForm();
												}}
												onBlur={(e) => {
													validateForm();
												}}
												onFocus={(e) => {
													touched.previousEmploymentDate_start = e;
												}}
												hasError={touched.previousEmploymentDate_start && errors.previousEmploymentDate_start}
												errorMessage={errors.previousEmploymentDate_start}
												disableConfirm={true} // hide OK button
												onClean={() => {
													setDataRequestFormObject({ ...dataRequestFormObject, previousEmploymentDate_start: "" });
													values.previousEmploymentDate_start = null;

												}}
											/>

											<DateInput
												id={"previousEmploymentDate_end"}
												name={"previousEmploymentDate_end"}
												value={dataRequestFormObject.previousEmploymentDate_end}
												label={"End Date"}
												isRequired={isPreviousEmp === 1 ? true : false}
												disableFuture={true}
												onChange={(date) => {
													if (date) {
														let tempEndDate = date.toLocaleDateString('en-US', { year: "numeric", month: "2-digit", day: "2-digit", });
														setDataRequestFormObject({ ...dataRequestFormObject, previousEmploymentDate_end: tempEndDate });
														values.previousEmploymentDate_end = tempEndDate;
													} else {
														setDataRequestFormObject({ ...dataRequestFormObject, previousEmploymentDate_end: "" });
														values.previousEmploymentDate_end = null;
													}
													validateForm();
												}}
												onBlur={(e) => { validateForm(); }}
												onFocus={(e) => {
													touched.previousEmploymentDate_end = e;
												}}
												hasError={touched.previousEmploymentDate_end && errors.previousEmploymentDate_end}
												errorMessage={errors.previousEmploymentDate_end}
												disableConfirm={true} // hide OK button
												onClean={() => {
													setDataRequestFormObject({ ...dataRequestFormObject, previousEmploymentDate_end: "" });
													values.previousEmploymentDate_end = null;
												}}
											/>
										</div>
										<InputTxt
											id="previousEmployeeId"
											name="previousEmployeeId"
											labelText="Previous ID number"
											helpMessage="ID is a 6-digit number"
											isRequired={false}
											errorMessage={errors.previousEmployeeId}
											hasError={touched.previousEmployeeId && errors.previousEmployeeId}
											onChange={handleChange}
											onBlur={handleBlur}
											maxLength={"6"}
											size="6"
											value={values.previousEmployeeId}
											getTextString={(e) => setDataRequestFormObject({ ...dataRequestFormObject, previousEmployeeId: e.trim() })}
										/>

									</div>
									<div className="inputBox_short_20">
										<InputTxt
											id="ssnLastFourDigits"
											name="ssnLastFourDigits"
											labelText="Last four digits of National ID/Social security number"
											isRequired={true}
											errorMessage={errors.ssnLastFourDigits}
											hasError={touched.ssnLastFourDigits && errors.ssnLastFourDigits}
											onChange={handleChange}
											onBlur={(e) => {
												setDataRequestFormObject({ ...dataRequestFormObject, ssnLastFourDigits: e.target.value });
												values.ssnLastFourDigits = e.target.value;
												touched.ssnLastFourDigits = e;
												validateForm();
											}}
											maxLength={"4"}
											size="4"
											value={values.ssnLastFourDigits}
											getTextString={(e) => {
												setDataRequestFormObject({ ...dataRequestFormObject, ssnLastFourDigits: e.trim() });
												values.ssnLastFourDigits = e;
											}}
										/>
									</div>
								</div>

								<hr className="hr--light" />
								<div className="div_1_col horizontal_div">

									<Button
										text={"SUBMIT DATA REQUEST FORM"}
										styleName={"button button--primary"}
										id={"button_submit"}
										type="submit"
										onClick={(e) => { populateNameEmail(values); setFormSubmitted(true); validateForm(); window.scrollTo({ top: 0, left: 0, behavior: 'auto' }); dobRef.current.doValidate(); }}
									/>
								</div>

							</div>
						</form>


					)}
				</Formik>
			</div>
		</div>
	)

	// } else {
	//	return null;
	//}

};



export default DataRequestForm;
